<template>
  <router-view />
</template>

<script>
import { loadScript, initGtrUA, launchGAPageView, launchGAEvent } from '@/utils/gtm.util'
import { GTM_KEY, UA_KEY } from '@/config/google-keys.config'

export default {
  name: 'App',
  created() {
    loadScript(GTM_KEY)
    initGtrUA(UA_KEY)
  },
  watch: {
    $route(to) {
      launchGAEvent(this.$route.params.id, 'pageviews', to.name)
      launchGAPageView(to.name)
    },
  },
}
</script>
